import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';

// Custom hook for managing current page state
export const usePagination = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const parsed = parseInt(searchParams.get('page') ?? '', 10);
  const currentPage = Number.isNaN(parsed) ? 1 : Math.max(1, parsed);

  const [pageSize, setPageSize] = useState(20);

  const setPage = (page: number) => {
    setSearchParams(
      (prev) => {
        const next = new URLSearchParams(prev);

        if (page <= 1) {
          next.delete('page');
        } else {
          next.set('page', String(page));
        }

        return next;
      },
      { replace: true },
    );
  };

  return {
    currentPage,
    pageSize,
    setPage,
    setPageSize,
  };
};
